import * as React from "react";
import { Box } from "@mui/material";
import PatientIdentifierForm from "../forms/PatientIdentifierForm";

export default function PatientIdentifiersCreatePage() {
  return (
    <Box sx={{ p: 2 }}>
      <PatientIdentifierForm />
    </Box>
  );
}